import React, { useEffect, useState, useContext } from 'react';

import { ShoppingStart } from '../../components/ShoppingStart';

// import useSound from 'use-sound';
// import se_01 from '../../sound/s01_item_num.mp3';
// import se_08 from '../../sound/s08_se_delay0.mp3';


export const ShoppingList = (props) => {

const ShoppingStartContext = useContext(ShoppingStart);
// const [se01_item_num,se01_item_num_controls] = useSound(se_01);
// const [se08_se] = useSound(se_08);
// console.log(props.errNum);

// useEffect(() => {
// 	if(props.soundState !== "se01_item_num" && props.soundState !== ""){
// 		se01_item_num_controls.stop();
// 	}
// }, [props.soundState]);

const onSelectNum = (bc,num) => {
	// e.stopPropagation();
	// console.log("bc: "+bc);
	// console.log("num: "+num);
	if(props.showItemNum.length === 0){

		//お買物API：画面遷移API（数量変更表示
		props.okaimonoAPI_didScreenTransition("change_quantity");

		props.setShowItemNum([bc,num]);
		// se08_se();
		props.setSoundState("se08_se");
		setTimeout(function(){
			// se01_item_num_controls.stop();
			props.setSoundState("se01_item_num");
			// se01_item_num();
		}, 300);
	}
}
const onItemDelete = (bc,num) => {

	//お買物API：画面遷移API（削除確認ポップアップ
	// props.okaimonoAPI_didScreenTransition("delete_popup");
	//お買物API：画面遷移API（ポップアップ表示
	props.okaimonoAPI_didScreenTransition("popup");

	// e.stopPropagation();
	props.setDelModal([bc,num]);
	// se08_se();
	props.setSoundState("se08_se");
}

const [shoppingArr, setShoppingArr] = useState([]);
const [shoppingBarcode, setShoppingBarcode] = useState([]);

//不定貫とバンドル以外の重複するバーコード商品をまとめたリスト
const [shoppingArrFix, setShoppingArrFix] = useState([]);

useEffect(() => {
	if(props.appHeight !== ""){
		let element3 = document.querySelector('.shoppingAddItem');
		if(element3){
			element3.style.height = props.appHeight + 'px';
		}
		let element4 = document.querySelector('.shoppingListFrame');
		if(element4){
			element4.style.height = props.appHeight + 'px';
		}
	}else {
		setTimeout(function(){
			let sHeight = window.innerHeight;
			let wzoom = window.innerWidth / 390;
			let zHeight = sHeight * wzoom;
			let nHeight = sHeight - (zHeight - sHeight);
			console.log("sHeight: "+sHeight);
			console.log("wzoom: "+wzoom);
			console.log("zHeight: "+zHeight);
			console.log("nHeight: "+nHeight);
			let element = document.querySelector('.shoppingAddItem');
			if (element) {
				element.style.height = nHeight + 'px';
			}
			let element2 = document.querySelector('.shoppingListFrame');
			if (element2) {
				element2.style.height = nHeight + 'px';
			}
			if(props.appHeight === ""){
				props.setAppHeight(nHeight);
			}
			//買物一覧、スキャン画面 広告表示用
			// let adjustedH = nHeight - (198 * wzoom);
			// let adjustedH = nHeight - 198;
			let adjustedH;
			if(props.isIOS && props.isIphoneHomeButton){ //iOS：ホームボタンあり
				console.log("買物一覧 広告表示用 iOS：ホームボタンあり");
				adjustedH = nHeight - (198*(390 / window.innerWidth));
			}else if(props.isIOS && !props.isIphoneHomeButton){ //iOS：ホームボタンなし
				console.log("買物一覧 広告表示用 iOS：ホームボタンなし");
				adjustedH = nHeight - (219*(390 / window.innerWidth));
			}else{ //Android
				console.log("買物一覧 広告表示用 Android");
				adjustedH = nHeight - (198*(390 / window.innerWidth));
			}
			props.setAdjustedHeight(adjustedH);
		}, 100);
	}

	if(props.shoppingData){
		// console.log("あああ");
		if (props.shoppingData.data) { //SUCCESS
			// console.log("いいいい");

			let itemArr = [];
			let itemBarcode = [];

			if(props.shoppingData.data.resultItemMasterList){
				console.log("length: "+props.shoppingData.data.resultItemMasterList.length);

				for(var i=0;i<props.shoppingData.data.resultItemMasterList.length;i++){
					if(props.shoppingData.data.resultItemMasterList.bundlesetprice !== null){ //バンドル商品
						// var bcode = props.shoppingData.data.resultItemMasterList[i].itemList[0].barCode;
						// console.log("bcode: "+bcode);
						// console.log("itemBarcode.indexOf(bcode): "+itemBarcode.indexOf(bcode));
						// if(itemBarcode.indexOf(bcode) === -1){
						// 	itemBarcode.push(bcode);
						itemArr.push(props.shoppingData.data.resultItemMasterList[i]);
						// }else{
						// 	var bpos = itemBarcode.indexOf(bcode);
						// 	itemArr[bpos].count += 1;
						// }
					}else{ //通常商品
						var bcode = props.shoppingData.data.resultItemMasterList[i].barCode;
						console.log("bcode: "+bcode);
						console.log("itemBarcode.indexOf(bcode): "+itemBarcode.indexOf(bcode));
						if(itemBarcode.indexOf(bcode) === -1){
							itemBarcode.push(bcode);
							itemArr.push(props.shoppingData.data.resultItemMasterList[i]);
						}else{
							var bpos = itemBarcode.indexOf(bcode);
							itemArr[bpos].count += 1;
						}
					}
				}
			}else{
				console.log("length: "+props.shoppingData.data.saleList.length);

				for(var i=0;i<props.shoppingData.data.saleList.length;i++){
					if(props.shoppingData.data.saleList.bundlesetprice !== null){ //バンドル商品
						// var bcode = props.shoppingData.data.saleList[i].itemList[0].barCode;
						// console.log("bcode: "+bcode);
						// console.log("itemBarcode.indexOf(bcode): "+itemBarcode.indexOf(bcode));
						// if(itemBarcode.indexOf(bcode) === -1){
						// 	itemBarcode.push(bcode);
						itemArr.push(props.shoppingData.data.saleList[i]);
						// }else{
						// 	var bpos = itemBarcode.indexOf(bcode);
						// 	itemArr[bpos].count += 1;
						// }
					}else{ //通常商品
						var bcode = props.shoppingData.data.saleList[i].barCode;
						console.log("bcode: "+bcode);
						console.log("itemBarcode.indexOf(bcode): "+itemBarcode.indexOf(bcode));
						if(itemBarcode.indexOf(bcode) === -1){
							itemBarcode.push(bcode);
							itemArr.push(props.shoppingData.data.saleList[i]);
						}else{
							var bpos = itemBarcode.indexOf(bcode);
							itemArr[bpos].count += 1;
						}
					}
				}
			}
			console.log("itemArr:");
			console.log(itemArr);

			props.setShoppingArr(itemArr);
			setShoppingBarcode(itemBarcode);

			// const obj = props.shoppingData.data.resultItemMasterList;
			// for (const key in obj) {
			// 	if (obj.hasOwnProperty(key)) {
			// 		console.log(`${key}: ${obj[key]}`);
			// 	}
			// }
			// console.log("shoppingData.data: success");
			// console.log(`【shoppingData】 sumIncludeTaxPrice: ${props.shoppingData.data.sumIncludeTaxPrice}`);
			// console.log(`【shoppingData】 sumSellPrice: ${props.shoppingData.data.sumSellPrice}`);
			// console.log(`【shoppingData】 sumItemCount: ${props.shoppingData.data.sumItemCount}`);
			// console.log(`【shoppingData】 resultItemMasterList receiptKanji: ${props.shoppingData.data.resultItemMasterList[0].receiptKanji}`);
			// console.log(`【shoppingData】 resultItemMasterList count: ${props.shoppingData.data.resultItemMasterList[0].count}`);
			// console.log(`【shoppingData】 resultItemMasterList sellPrice: ${props.shoppingData.data.resultItemMasterList[0].sellPrice}`);
			// console.log(`【shoppingData】 resultItemMasterList itemUrl: ${props.shoppingData.data.resultItemMasterList[0].itemUrl}`);
		}else{ //ERROR
			// console.log("ううう");
			// console.log("shoppingData.data: error");
		}
	}else{
		// console.log("えええ");
		// console.log("shoppingData: No Data");
	}
}, [props.shoppingData]);


useEffect(() => {
	console.log("props.shoppingArr:");
	console.log(props.shoppingArr);

	// Map を利用して重複を管理
	const groupedMap = new Map();

	// 元の順番を維持して処理
	const result = props.shoppingArr.map((item) => {
		if (item.promotionnumber === null && item.freshFlag === "0") {
			// 重複をまとめる条件
			if (groupedMap.has(item.barCode)) {
				// 既存アイテムに count を加算
				const existingItem = groupedMap.get(item.barCode);
				existingItem.count += item.count || 1;
				return null; // 重複アイテムはスキップ
			} else {
				// 新規アイテムを登録
				const newItem = { ...item };
				groupedMap.set(item.barCode, newItem);
				return newItem;
			}
		} else {
			// 重複処理しないアイテムはそのまま返す
			return item;
		}
	}).filter(Boolean); // null を除外

	setShoppingArrFix(result);

	console.log("shoppingArrFix:");
	console.log(result);
}, [props.shoppingArr]);


return (

	<>
		{
			(() => {
				// if (props.shoppingArr.length === 0) {
				if (shoppingArrFix.length === 0) {

					const shoppingHeight = window.innerHeight;
					let shoppingHeightSmall = false;
					if(shoppingHeight <= 670){
						shoppingHeightSmall = true;
					}
					return(
						<div className={`shoppingAddItem ${ShoppingStartContext.data.bonusFlag === 1 || ShoppingStartContext.data.lotteryFlag === 1 ? 'is_kujibonus' : ''}`}>
							<figure className={`shoppingAddItem_img ${shoppingHeightSmall ? 'is_small' : ''}`}>
								<p className="shoppingAddItem_txt">商品のバーコードを<br/>スキャンしてください</p>
								<span>
									<img src="/images/home_additem.png" alt="" width="196" height="120"/>
								</span>
							</figure>
						</div>
					)
				} else {

				return (
					<div className="shoppingListFrame">
					<div className="shoppingList">

					{/* {props.shoppingArr.map((item, index) => { */}
					{shoppingArrFix.map((item, index) => {
						if(item.itemList !== null){ //バンドル商品
							return (
								<div key={index} data-barcode={item.itemList[0].barCode} className="shoppingList_box is_bundle">
									<div className="shoppingList_frame">
									{item.itemList.map((sitem, sindex) => (
										<>
										<div key={sindex} className={`shoppingList_closeBtn ${"shoppingList_closeBtn_bundle"+sindex}`} onClick={() => onItemDelete(sitem.barCode,1)}>
											<span>
												<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
											</span>
										</div>
										<div className="shoppingList_in">
											<div className="shoppingList_img">
												<img src={sitem.itemUrl ? sitem.itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
											</div>
											<p className="shoppingList_name">{sitem.receiptKanji}</p>
											<div className="shoppingList_priceBox">
												<p className="shoppingList_price">
													<span className={`shoppingList_price_default ${item.bundlesetprice ? 'cancel' : ''}`}><small>¥</small>
													{(sitem.sellPrice).toLocaleString('ja-JP')}
													</span>
												</p>
											</div>
										</div>
										</>
									))}
										{/* <button className="shoppingList_closeBtn" onClick={() => onItemDelete(item.itemList[0].barCode,1)}>
											<span>
												<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
											</span>
										</button>
										<div className="shoppingList_in">
											<div className="shoppingList_img">
												<img src={item.itemList[0].itemUrl ? item.itemList[0].itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
											</div>
											<p className="shoppingList_name">{item.itemList[0].receiptKanji}</p>
											<div className="shoppingList_priceBox">
												<p className="shoppingList_price">
													<span className={`shoppingList_price_default ${item.bundlesetprice ? 'cancel' : ''}`}><small>¥</small>
													{item.itemList[0].sellPrice}
													</span>
												</p>
											</div>
										</div>
										<button className="shoppingList_closeBtn shoppingList_closeBtn_bundle" onClick={() => onItemDelete(item.itemList[1].barCode,1)}>
											<span>
												<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
											</span>
										</button>
										<div className="shoppingList_in">
											<div className="shoppingList_img">
												<img src={item.itemList[1].itemUrl ? item.itemList[1].itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
											</div>
											<p className="shoppingList_name">{item.itemList[1].receiptKanji}</p>
											<div className="shoppingList_priceBox">
												<p className="shoppingList_price">
													<span className={`shoppingList_price_default ${item.bundlesetprice ? 'cancel' : ''}`}><small>¥</small>
													{item.itemList[1].sellPrice}
													</span>
												</p>
											</div>
										</div> */}
										<div className="shoppingList_discount">
											<p className="shoppingList_discount_txt">まとめ値引<strong>{(item.summaryDiscount).toLocaleString('ja-JP')}</strong>円OFF</p>
											<p className="shoppingList_discount_price"><small>¥</small>{(item.bundlesetprice).toLocaleString('ja-JP')}</p>
										</div>
									</div>
								</div>
							)
						}else{ //通常商品
							return (
							<div key={index} data-barcode={item.barCode} className={`shoppingList_box ${item.count > 1 ? 'is_multi' : ''}`}>
								<div className="shoppingList_frame">
									<div className="shoppingList_closeBtn" onClick={() => onItemDelete(item.barCode,item.count)}>
										<span>
											<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
										</span>
									</div>
									<div className="shoppingList_in">
										<div className="shoppingList_img">
											{/* <img src={`${item.itemUrl}`} alt="" width="40" height="40"/> */}
											<img src={item.itemUrl ? item.itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
										</div>
										<p className="shoppingList_name">{item.receiptKanji}</p>
										<div className="shoppingList_priceBox">
											<p className="shoppingList_price">
												<span className={`shoppingList_price_default ${item.discountSellPrice ? 'cancel' : ''}`}><small>¥</small>
												{/* {item.discountSellPrice ? item.discountSellPrice :
												item.sellPrice} */}
												{(item.sellPrice).toLocaleString('ja-JP')}
												</span>
											</p>
											{
												(() => {
													if (item.freshFlag == "0") { //不定貫の判断項目
													return(
													<p className="shoppingList_num" data-num={item.count} onClick={() => onSelectNum(item.barCode,item.count)}>
														<span>
															<img src="/images/icn_pulldown01.svg" alt="" width="12" height="12" />
														</span>
														{item.count}
													</p>
													)
													}
												})()
											}
										</div>
									</div>
									{
										(() => {
											if (item.discountType === 1) {
												return(
													<div className="shoppingList_discount">
														<p className="shoppingList_discount_txt">レジにて<strong>{(item.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
														<p className="shoppingList_discount_price"><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
													</div>
												)
											}else if (item.discountType === 2) {
												return(
													<div className="shoppingList_discount">
														<p className="shoppingList_discount_txt">レジにて<strong>{item.discountAmount}</strong>%OFF</p>
														<p className="shoppingList_discount_price"><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
													</div>
												)
											}else if (item.discountType === 3) {
												return(
													<div className="shoppingList_discount">
														<p className="shoppingList_discount_txt">レジにて</p>
														<p className="shoppingList_discount_price"><small>¥</small>{(item.discountSellPrice).toLocaleString('ja-JP')}</p>
													</div>
												)
											}
										})()
									}
								</div>
							</div>
							)
						}
					}
					)}
					<p class="shoppingList_note">表示価格は本体価格となります</p>
					</div>
					</div>
				)
				}
			})()
		}
	</>
)

}
